import'./style.css';
import'./index.css';
import Logo from '../../assets/Selo.jpg';
import Fundo from '../../assets/Fundo.jpg';
import { useNavigate, Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import api from '../../services/api.js';

function Login(props)
{
     const [usuario, setUsuario] = useState("");
     const [senha, setSenha] = useState("");
     const [acesso, setAcesso] = useState("");
     const [pesquisa, setPesquisa] = useState("");

     let xpto = "verificaemail.php/";
     
     function MyChangeUsuario(event) {
      setPesquisa('');  
      setUsuario(event.target.value);
    }
  
    function MyChangeSenha(event){
      setSenha(event.target.value);
    }
   
    const navigate = useNavigate();

    async function ProcessaLogin(event)
    {
        event.preventDefault();

        
        if  ( usuario.match('@')) {
            setPesquisa(xpto);
            
        }  else {setPesquisa(""); }    

        if  ( usuario ==='') {
            alert('Favor informar dados de usuário !');
            return;  
        }

        if  ( senha ==='') {
            alert('Favor informar senha de acesso !');
            return;  
        }

        if  ( usuario.match('@')) {
            setPesquisa("verificaemail.php/");
        }       

        const response = await api.get('/cliente/login/'+pesquisa+'?u='+usuario+'&p='+senha);
       
        const IdUsuario =       response.data[0].IdUsuario;
        const NomeUsuario =     response.data[0].Nome;
        localStorage.setItem("IdUsuario", IdUsuario );
        localStorage.setItem("NomeUsuario", NomeUsuario );
        localStorage.setItem("usuario", usuario );
        
        const resposta = await api.get('/cliente/home/index.php/?e='+usuario);
       
        const UltimaVisita =    resposta.data[0].UltimaVisita;
        
        localStorage.setItem("UltimaVisita", UltimaVisita );
        
        const Proxima = await api.get('/cliente/home/proximo.php/?e='+usuario);
       
        const ProximaVisita =   Proxima.data[0].ProximaVisita;
        const Dias =            Proxima.data[0].Dias;
      
        localStorage.setItem("ProximaVisita", ProximaVisita);
        localStorage.setItem("Dias", Dias );

        const Qtde = await api.get('/cliente/home/QtdeCtr.php/?e='+usuario);
        const QtdeCtr =            Qtde.data[0].QtdeCtr;
      
        localStorage.setItem("QtdeCtr", QtdeCtr );

        if   (Number(IdUsuario) > 0)
            
             {
                 setAcesso(null);
                 alert('Olá \n' + NomeUsuario + '\nSeja bem vindo(a) à nossa área de cliente !')          
                 navigate('Home/');
            }
        else  { setAcesso('N'); }
    }

const firstRenderRef = useRef(true);

useEffect(() => {
  if (firstRenderRef.current) {
    firstRenderRef.current = false;
  }

  if (pesquisa.length < 1) {
    setPesquisa("");
  }
}, [pesquisa]);

    return <div className="row"> 
        <div className="col-sm-3 d-flex - justify-content-center align-items-center text-center">
            <form className="form-login">
                <div className="top">
                         <img src={Logo} alt="Imagem" style={{ height: "100px", margin: "2px" }} />

                </div> 
                <h4 className='mt-3'>Área do cliente</h4>
              
                <h7 className='mb-3'>Acesse sua conta</h7>      
             
                <div className="form-floating">
                    <input type ="cnpj" className="form-control" id="FloatingInput"
                        placeholder='CNPJ/CPF ou email' onChange={MyChangeUsuario}  />
                    <label htmlFor='FloatingInput'>CNPJ/CPF ou email</label>
                </div>

                <div className="form-floating">
                    <input type = "password" className="form-control" id="FloatingInput"
                        placeholder='senha'  onChange={MyChangeSenha}    />
                    <label htmlFor='FloatingInput'>senha</label>
                </div>

                <button className="w-100   btn btn-primary"  type='button' onClick={ProcessaLogin}>
                    <span className='ms-2'>Acesso ao Sistema</span>                  
                </button>

               
                { acesso ==='N' ?
                        <div className="alert alert-warning mt-2" role="alert">
                            CNPJ/CPF ou senha inválidos !
                        </div>
                  : null    
                }

               <div className="link" >
                    
                    <Link to='/ResetSenha'><i className='mx-3'></i>Esqueci minha senha</Link>     
                    
                    <Link to='/CriaConta'><i className="mx-3"></i>Criar uma conta</Link>           
              </div>

               
                <div class="riverclear">
                    <p>Desenvolvido por River Clear development systems </p>
                </div>


             </form>

        </div>
        <div className="col-sm-9 pix-0 d-none d-sm-block">
            
                <img  className='mt-5' src={Fundo} alt="Imagem não encontrada"/>
            
        </div>
    </div>    
    
}
export default Login;